import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import ThreeWayCallDetailsModal from './three-way/threeWayCallDetailsModal';
import Profile from './Profile';

const DetailsModal = ({
  user,
  isOpen,
  clear,
  clearLeads,
  close,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={() => {
      clear();
      clearLeads();
      close();
    }}
    onClosed={() => {
      clear();
      clearLeads();
    }}
    className="mw-100 font-small fade-in"
    contentClassName="h-100 d-flex border-0 flex-column"
    zIndex="100000"
    style={{ height: '92vh' }}
    id="user-admin-details-modal"
  >
    <Profile user={user} modal />
    <ThreeWayCallDetailsModal user={user} />
  </Modal>
);

const mapStateToProps = (store) => ({
  isOpen: store.modals.editInfoOpen,
  username: store.modals.username,
});

const mapDispatchToProps = {
  close: () => ({ type: 'CLOSE_MODAL', modal: 'editInfoOpen' }),
  clear: () => ({ type: 'CLEAR_SELECTED_AGENT' }),
  clearLeads: () => ({ type: 'CLEAR_AGENT_LEADS' }),
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsModal);
